const br = [
  { id: 'BRAC', name: 'Acre' },
  { id: 'BRAL', name: 'Alagoas' },
  { id: 'BRAP', name: 'Amapá' },
  { id: 'BRAM', name: 'Amazonas' },
  { id: 'BRBA', name: 'Bahia' },
  { id: 'BRCE', name: 'Ceará' },
  { id: 'BRDF', name: 'Distrito Federal' },
  { id: 'BRES', name: 'Espírito Santo' },
  { id: 'BRGO', name: 'Goiás' },
  { id: 'BRMA', name: 'Maranhão' },
  { id: 'BRMT', name: 'Mato Grosso' },
  { id: 'BRMS', name: 'Mato Grosso do Sul' },
  { id: 'BRMG', name: 'Minas Gerais' },
  { id: 'BRPA', name: 'Pará' },
  { id: 'BRPB', name: 'Paraíba' },
  { id: 'BRPR', name: 'Paraná' },
  { id: 'BRPE', name: 'Pernambuco' },
  { id: 'BRPI', name: 'Piauí' },
  { id: 'BRRJ', name: 'Río de Janeiro' },
  { id: 'BRRN', name: 'Rio Grande do Norte' },
  { id: 'BRRS', name: 'Rio Grande do Sul' },
  { id: 'BRRO', name: 'Rondônia' },
  { id: 'BRRR', name: 'Roraima' },
  { id: 'BRSC', name: 'Santa Catarina' },
  { id: 'BRSP', name: 'São Paulo' },
  { id: 'BRSE', name: 'Sergipe' },
  { id: 'BRTO', name: 'Tocantins' }
]

const cl = [
  { id: 'CL11201',	name: 'Aisén' },
  { id: 'CL05602',	name: 'Algarrobo' },
  { id: 'CL13502',	name: 'Alhué' },
  { id: 'CL08314',	name: 'Alto Biobío' },
  { id: 'CL03302',	name: 'Alto del Carmen' },
  { id: 'CL01107',	name: 'Alto Hospicio' },
  { id: 'CL10202',	name: 'Ancud' },
  { id: 'CL04103',	name: 'Andacollo' },
  { id: 'CL09201',	name: 'Angol' },
  { id: 'CL12202',	name: 'Antártica' },
  { id: 'CL02101',	name: 'Antofagasta' },
  { id: 'CL08302',	name: 'Antuco' },
  { id: 'CL08202',	name: 'Arauco' },
  { id: 'CL15101',	name: 'Arica' },
  { id: 'CL13402',	name: 'Buin' },
  { id: 'CL16102',	name: 'Bulnes' },
  { id: 'CL05402',	name: 'Cabildo' },
  { id: 'CL12201',	name: 'Cabo de Hornos' },
  { id: 'CL08303',	name: 'Cabrero' },
  { id: 'CL02201',	name: 'Calama' },
  { id: 'CL10102',	name: 'Calbuco' },
  { id: 'CL03102',	name: 'Caldera' },
  { id: 'CL05502',	name: 'Calera' },
  { id: 'CL13403',	name: 'Calera de Tango' },
  { id: 'CL05302',	name: 'Calle Larga' },
  { id: 'CL15102',	name: 'Camarones' },
  { id: 'CL01402',	name: 'Camiña' },
  { id: 'CL04202',	name: 'Canela' },
  { id: 'CL08203',	name: 'Cañete' },
  { id: 'CL09102',	name: 'Carahue' },
  { id: 'CL05603',	name: 'Cartagena' },
  { id: 'CL05102',	name: 'Casablanca' },
  { id: 'CL10201',	name: 'Castro' },
  { id: 'CL05702',	name: 'Catemu' },
  { id: 'CL07201',	name: 'Cauquenes' },
  { id: 'CL13102',	name: 'Cerrillos' },
  { id: 'CL13103',	name: 'Cerro Navia' },
  { id: 'CL10401',	name: 'Chaitén' },
  { id: 'CL07202',	name: 'Chanco' },
  { id: 'CL03201',	name: 'Chañaral' },
  { id: 'CL06302',	name: 'Chépica' },
  { id: 'CL08103',	name: 'Chiguayante' },
  { id: 'CL11401',	name: 'Chile Chico' },
  { id: 'CL16101',	name: 'Chillán' },
  { id: 'CL16103',	name: 'Chillán Viejo' },
  { id: 'CL06303',	name: 'Chimbarongo' },
  { id: 'CL09121',	name: 'Cholchol' },
  { id: 'CL10203',	name: 'Chonchi' },
  { id: 'CL11202',	name: 'Cisnes' },
  { id: 'CL16202',	name: 'Cobquecura' },
  { id: 'CL10103',	name: 'Cochamó' },
  { id: 'CL11301',	name: 'Cochrane' },
  { id: 'CL06102',	name: 'Codegua' },
  { id: 'CL16203',	name: 'Coelemu' },
  { id: 'CL11101',	name: 'Coihaique' },
  { id: 'CL16302',	name: 'Coihueco' },
  { id: 'CL06103',	name: 'Coinco' },
  { id: 'CL07402',	name: 'Colbún' },
  { id: 'CL01403',	name: 'Colchane' },
  { id: 'CL13301',	name: 'Colina' },
  { id: 'CL09202',	name: 'Collipulli' },
  { id: 'CL06104',	name: 'Coltauco' },
  { id: 'CL04302',	name: 'Combarbalá' },
  { id: 'CL08101',	name: 'Concepción' },
  { id: 'CL13104',	name: 'Conchalí' },
  { id: 'CL05103',	name: 'Concón' },
  { id: 'CL07102',	name: 'Constitución' },
  { id: 'CL08204',	name: 'Contulmo' },
  { id: 'CL03101',	name: 'Copiapó' },
  { id: 'CL04102',	name: 'Coquimbo' },
  { id: 'CL08102',	name: 'Coronel' },
  { id: 'CL14102',	name: 'Corral' },
  { id: 'CL09103',	name: 'Cunco' },
  { id: 'CL09203',	name: 'Curacautín' },
  { id: 'CL13503',	name: 'Curacaví' },
  { id: 'CL10204',	name: 'Curaco de Vélez' },
  { id: 'CL08205',	name: 'Curanilahue' },
  { id: 'CL09104',	name: 'Curarrehue' },
  { id: 'CL07103',	name: 'Curepto' },
  { id: 'CL07301',	name: 'Curicó' },
  { id: 'CL10205',	name: 'Dalcahue' },
  { id: 'CL03202',	name: 'Diego de Almagro' },
  { id: 'CL06105',	name: 'Doñihue' },
  { id: 'CL13105',	name: 'El Bosque' },
  { id: 'CL16104',	name: 'El Carmen' },
  { id: 'CL13602',	name: 'El Monte' },
  { id: 'CL05604',	name: 'El Quisco' },
  { id: 'CL05605',	name: 'El Tabo' },
  { id: 'CL07104',	name: 'Empedrado' },
  { id: 'CL09204',	name: 'Ercilla' },
  { id: 'CL13106',	name: 'Estación Central' },
  { id: 'CL08104',	name: 'Florida' },
  { id: 'CL09105',	name: 'Freire' },
  { id: 'CL03303',	name: 'Freirina' },
  { id: 'CL10104',	name: 'Fresia' },
  { id: 'CL10105',	name: 'Frutillar' },
  { id: 'CL10402',	name: 'Futaleufú' },
  { id: 'CL14202',	name: 'Futrono' },
  { id: 'CL09106',	name: 'Galvarino' },
  { id: 'CL15202',	name: 'General Lagos' },
  { id: 'CL09107',	name: 'Gorbea' },
  { id: 'CL06106',	name: 'Graneros' },
  { id: 'CL11203',	name: 'Guaitecas' },
  { id: 'CL05503',	name: 'Hijuelas' },
  { id: 'CL10403',	name: 'Hualaihué' },
  { id: 'CL07302',	name: 'Hualañé' },
  { id: 'CL08112',	name: 'Hualpén' },
  { id: 'CL08105',	name: 'Hualqui' },
  { id: 'CL01404',	name: 'Huara' },
  { id: 'CL03304',	name: 'Huasco' },
  { id: 'CL13107',	name: 'Huechuraba' },
  { id: 'CL04201',	name: 'Illapel' },
  { id: 'CL13108',	name: 'Independencia' },
  { id: 'CL01101',	name: 'Iquique' },
  { id: 'CL05201',	name: 'Isla de Pascua' },
  { id: 'CL13603',	name: 'Isla de Maipo' },
  { id: 'CL05104',	name: 'Juan Fernández' },
  { id: 'CL13109',	name: 'La Cisterna' },
  { id: 'CL05504',	name: 'La Cruz' },
  { id: 'CL06202',	name: 'La Estrella' },
  { id: 'CL13110',	name: 'La Florida' },
  { id: 'CL13111',	name: 'La Granja' },
  { id: 'CL04104',	name: 'La Higuera' },
  { id: 'CL05401',	name: 'La Ligua' },
  { id: 'CL13112',	name: 'La Pintana' },
  { id: 'CL13113',	name: 'La Reina' },
  { id: 'CL04101',	name: 'La Serena' },
  { id: 'CL14201',	name: 'La Unión' },
  { id: 'CL14203',	name: 'Lago Ranco' },
  { id: 'CL11102',	name: 'Lago Verde' },
  { id: 'CL12102',	name: 'Laguna Blanca' },
  { id: 'CL08304',	name: 'Laja' },
  { id: 'CL13302',	name: 'Lampa' },
  { id: 'CL14103',	name: 'Lanco' },
  { id: 'CL06107',	name: 'Las Cabras' },
  { id: 'CL13114',	name: 'Las Condes' },
  { id: 'CL09108',	name: 'Lautaro' },
  { id: 'CL08201',	name: 'Lebu' },
  { id: 'CL07303',	name: 'Licantén' },
  { id: 'CL05802',	name: 'Limache' },
  { id: 'CL07401',	name: 'Linares' },
  { id: 'CL06203',	name: 'Litueche' },
  { id: 'CL05703',	name: 'Llaillay' },
  { id: 'CL10107',	name: 'Llanquihue' },
  { id: 'CL13115',	name: 'Lo Barnechea' },
  { id: 'CL13116',	name: 'Lo Espejo' },
  { id: 'CL13117',	name: 'Lo Prado' },
  { id: 'CL06304',	name: 'Lolol' },
  { id: 'CL09109',	name: 'Loncoche' },
  { id: 'CL07403',	name: 'Longaví' },
  { id: 'CL09205',	name: 'Lonquimay' },
  { id: 'CL08206',	name: 'Los Álamos' },
  { id: 'CL05301',	name: 'Los Andes' },
  { id: 'CL08301',	name: 'Los Ángeles' },
  { id: 'CL14104',	name: 'Los Lagos' },
  { id: 'CL10106',	name: 'Los Muermos' },
  { id: 'CL09206',	name: 'Los Sauces' },
  { id: 'CL04203',	name: 'Los Vilos' },
  { id: 'CL08106',	name: 'Lota' },
  { id: 'CL09207',	name: 'Lumaco' },
  { id: 'CL06108',	name: 'Machalí' },
  { id: 'CL13118',	name: 'Macul' },
  { id: 'CL14105',	name: 'Máfil' },
  { id: 'CL13119',	name: 'Maipú' },
  { id: 'CL06109',	name: 'Malloa' },
  { id: 'CL06204',	name: 'Marchihue' },
  { id: 'CL02302',	name: 'María Elena' },
  { id: 'CL13504',	name: 'María Pinto' },
  { id: 'CL14106',	name: 'Mariquina' },
  { id: 'CL07105',	name: 'Maule' },
  { id: 'CL10108',	name: 'Maullín' },
  { id: 'CL02102',	name: 'Mejillones' },
  { id: 'CL09110',	name: 'Melipeuco' },
  { id: 'CL13501',	name: 'Melipilla' },
  { id: 'CL07304',	name: 'Molina' },
  { id: 'CL04303',	name: 'Monte Patria' },
  { id: 'CL06110',	name: 'Mostazal' },
  { id: 'CL08305',	name: 'Mulchén' },
  { id: 'CL08306',	name: 'Nacimiento' },
  { id: 'CL06305',	name: 'Nancagua' },
  { id: 'CL12401',	name: 'Natales' },
  { id: 'CL06205',	name: 'Navidad' },
  { id: 'CL08307',	name: 'Negrete' },
  { id: 'CL16204',	name: 'Ninhue' },
  { id: 'CL05506',	name: 'Nogales' },
  { id: 'CL09111',	name: 'Nueva Imperial' },
  { id: 'CL16303',	name: 'Ñiquén' },
  { id: 'CL13120',	name: 'Ñuñoa' },
  { id: 'CL11302',	name: 'OHiggins' },
  { id: 'CL06111',	name: 'Olivar' },
  { id: 'CL02202',	name: 'Ollagüe' },
  { id: 'CL05803',	name: 'Olmué' },
  { id: 'CL10301',	name: 'Osorno' },
  { id: 'CL04301',	name: 'Ovalle' },
  { id: 'CL13604',	name: 'Padre Hurtado' },
  { id: 'CL09112',	name: 'Padre Las Casas' },
  { id: 'CL04105',	name: 'Paiguano' },
  { id: 'CL14107',	name: 'Paillaco' },
  { id: 'CL13404',	name: 'Paine' },
  { id: 'CL10404',	name: 'Palena' },
  { id: 'CL06306',	name: 'Palmilla' },
  { id: 'CL14108',	name: 'Panguipulli' },
  { id: 'CL05704',	name: 'Panquehue' },
  { id: 'CL05403',	name: 'Papudo' },
  { id: 'CL06206',	name: 'Paredones' },
  { id: 'CL07404',	name: 'Parral' },
  { id: 'CL13121',	name: 'Pedro Aguirre Cerda' },
  { id: 'CL07106',	name: 'Pelarco' },
  { id: 'CL07203',	name: 'Pelluhue' },
  { id: 'CL16105',	name: 'Pemuco' },
  { id: 'CL07107',	name: 'Pencahue' },
  { id: 'CL08107',	name: 'Penco' },
  { id: 'CL13605',	name: 'Peñaflor' },
  { id: 'CL13122',	name: 'Peñalolén' },
  { id: 'CL06307',	name: 'Peralillo' },
  { id: 'CL09113',	name: 'Perquenco' },
  { id: 'CL05404',	name: 'Petorca' },
  { id: 'CL06112',	name: 'Peumo' },
  { id: 'CL01405',	name: 'Pica' },
  { id: 'CL06113',	name: 'Pichidegua' },
  { id: 'CL06201',	name: 'Pichilemu' },
  { id: 'CL16106',	name: 'Pinto' },
  { id: 'CL13202',	name: 'Pirque' },
  { id: 'CL09114',	name: 'Pitrufquén' },
  { id: 'CL06308',	name: 'Placilla' },
  { id: 'CL16205',	name: 'Portezuelo' },
  { id: 'CL12301',	name: 'Porvenir' },
  { id: 'CL01401',	name: 'Pozo Almonte' },
  { id: 'CL12302',	name: 'Primavera' },
  { id: 'CL13123',	name: 'Providencia' },
  { id: 'CL05105',	name: 'Puchuncaví' },
  { id: 'CL09115',	name: 'Pucón' },
  { id: 'CL13124',	name: 'Pudahuel' },
  { id: 'CL13201',	name: 'Puente Alto' },
  { id: 'CL10101',	name: 'Puerto Montt' },
  { id: 'CL10302',	name: 'Puerto Octay' },
  { id: 'CL10109',	name: 'Puerto Varas' },
  { id: 'CL06309',	name: 'Pumanque' },
  { id: 'CL04304',	name: 'Punitaqui' },
  { id: 'CL12101',	name: 'Punta Arenas' },
  { id: 'CL10206',	name: 'Puqueldón' },
  { id: 'CL09208',	name: 'Purén' },
  { id: 'CL10303',	name: 'Purranque' },
  { id: 'CL05705',	name: 'Putaendo' },
  { id: 'CL15201',	name: 'Putre' },
  { id: 'CL10304',	name: 'Puyehue' },
  { id: 'CL10207',	name: 'Queilén' },
  { id: 'CL10208',	name: 'Quellón' },
  { id: 'CL10209',	name: 'Quemchi' },
  { id: 'CL08308',	name: 'Quilaco' },
  { id: 'CL13125',	name: 'Quilicura' },
  { id: 'CL08309',	name: 'Quilleco' },
  { id: 'CL16107',	name: 'Quillón' },
  { id: 'CL05501',	name: 'Quillota' },
  { id: 'CL05801',	name: 'Quilpué' },
  { id: 'CL10210',	name: 'Quinchao' },
  { id: 'CL06114',	name: 'Quinta de Tilcoco' },
  { id: 'CL13126',	name: 'Quinta Normal' },
  { id: 'CL05107',	name: 'Quintero' },
  { id: 'CL16201',	name: 'Quirihue' },
  { id: 'CL06101',	name: 'Rancagua' },
  { id: 'CL16206',	name: 'Ránquil' },
  { id: 'CL07305',	name: 'Rauco' },
  { id: 'CL13127',	name: 'Recoleta' },
  { id: 'CL09209',	name: 'Renaico' },
  { id: 'CL13128',	name: 'Renca' },
  { id: 'CL06115',	name: 'Rengo' },
  { id: 'CL06116',	name: 'Requínoa' },
  { id: 'CL07405',	name: 'Retiro' },
  { id: 'CL05303',	name: 'Rinconada' },
  { id: 'CL14204',	name: 'Río Bueno' },
  { id: 'CL07108',	name: 'Río Claro' },
  { id: 'CL04305',	name: 'Río Hurtado' },
  { id: 'CL11402',	name: 'Río Ibáñez' },
  { id: 'CL10305',	name: 'Río Negro' },
  { id: 'CL12103',	name: 'Río Verde' },
  { id: 'CL07306',	name: 'Romeral' },
  { id: 'CL09116',	name: 'Saavedra' },
  { id: 'CL07307',	name: 'Sagrada Familia' },
  { id: 'CL04204',	name: 'Salamanca' },
  { id: 'CL05601',	name: 'San Antonio' },
  { id: 'CL13401',	name: 'San Bernardo' },
  { id: 'CL16301',	name: 'San Carlos' },
  { id: 'CL07109',	name: 'San Clemente' },
  { id: 'CL05304',	name: 'San Esteban' },
  { id: 'CL16304',	name: 'San Fabián' },
  { id: 'CL05701',	name: 'San Felipe' },
  { id: 'CL06301',	name: 'San Fernando' },
  { id: 'CL12104',	name: 'San Gregorio' },
  { id: 'CL16108',	name: 'San Ignacio' },
  { id: 'CL07406',	name: 'San Javier' },
  { id: 'CL13129',	name: 'San Joaquín' },
  { id: 'CL13203',	name: 'San José de Maipo' },
  { id: 'CL10306',	name: 'San Juan de la Costa' },
  { id: 'CL13130',	name: 'San Miguel' },
  { id: 'CL16305',	name: 'San Nicolás' },
  { id: 'CL10307',	name: 'San Pablo' },
  { id: 'CL13505',	name: 'San Pedro' },
  { id: 'CL02203',	name: 'San Pedro de Atacama' },
  { id: 'CL08108',	name: 'San Pedro de la Paz' },
  { id: 'CL07110',	name: 'San Rafael' },
  { id: 'CL13131',	name: 'San Ramón' },
  { id: 'CL08310',	name: 'San Rosendo' },
  { id: 'CL06117',	name: 'San Vicente' },
  { id: 'CL08311',	name: 'Santa Bárbara' },
  { id: 'CL06310',	name: 'Santa Cruz' },
  { id: 'CL08109',	name: 'Santa Juana' },
  { id: 'CL05706',	name: 'Santa María' },
  { id: 'CL13101',	name: 'Santiago' },
  { id: 'CL05606',	name: 'Santo Domingo' },
  { id: 'CL02103',	name: 'Sierra Gorda' },
  { id: 'CL13601',	name: 'Talagante' },
  { id: 'CL07101',	name: 'Talca' },
  { id: 'CL08110',	name: 'Talcahuano' },
  { id: 'CL02104',	name: 'Taltal' },
  { id: 'CL09101',	name: 'Temuco' },
  { id: 'CL07308',	name: 'Teno' },
  { id: 'CL09117',	name: 'Teodoro Schmidt' },
  { id: 'CL03103',	name: 'Tierra Amarilla' },
  { id: 'CL13303',	name: 'Tiltil' },
  { id: 'CL12303',	name: 'Timaukel' },
  { id: 'CL08207',	name: 'Tirúa' },
  { id: 'CL02301',	name: 'Tocopilla' },
  { id: 'CL09118',	name: 'Toltén' },
  { id: 'CL08111',	name: 'Tomé' },
  { id: 'CL12402',	name: 'Torres del Paine' },
  { id: 'CL11303',	name: 'Tortel' },
  { id: 'CL09210',	name: 'Traiguén' },
  { id: 'CL16207',	name: 'Treguaco' },
  { id: 'CL08312',	name: 'Tucapel' },
  { id: 'CL14101',	name: 'Valdivia' },
  { id: 'CL03301',	name: 'Vallenar' },
  { id: 'CL05101',	name: 'Valparaíso' },
  { id: 'CL07309',	name: 'Vichuquén' },
  { id: 'CL09211',	name: 'Victoria' },
  { id: 'CL04106',	name: 'Vicuña' },
  { id: 'CL09119',	name: 'Vilcún' },
  { id: 'CL07407',	name: 'Villa Alegre' },
  { id: 'CL05804',	name: 'Villa Alemana' },
  { id: 'CL09120',	name: 'Villarrica' },
  { id: 'CL05109',	name: 'Viña del Mar' },
  { id: 'CL13132',	name: 'Vitacura' },
  { id: 'CL07408',	name: 'Yerbas Buenas' },
  { id: 'CL08313',	name: 'Yumbel' },
  { id: 'CL16109',	name: 'Yungay' },
  { id: 'CL05405',	name: 'Zapallar' }
]

const us = [
  { id: 'US-AL', name: 'Alabama' },
  { id: 'US-AK', name: 'Alaska' },
  { id: 'US-AZ', name: 'Arizona' },
  { id: 'US-AR', name: 'Arkansas' },
  { id: 'USCA', name: 'California' },
  { id: 'US-NC', name: 'Carolina del Norte' },
  { id: 'US-SC', name: 'Carolina del Sur' },
  { id: 'US-CO', name: 'Colorado' },
  { id: 'US-CT', name: 'Connecticut' },
  { id: 'US-ND', name: 'Dakota del Norte' },
  { id: 'US-SD', name: 'Dakota del Sur' },
  { id: 'US-DE', name: 'Delaware' },
  { id: 'US-FL', name: 'Florida' },
  { id: 'US-GA', name: 'Georgia' },
  { id: 'US-GU', name: 'Guam' },
  { id: 'US-HI', name: 'Hawái' },
  { id: 'US-ID', name: 'Idaho' },
  { id: 'US-IL', name: 'Illinois' },
  { id: 'US-IN', name: 'Indiana' },
  { id: 'US-IA', name: 'Iowa' },
  { id: 'US-MP', name: 'Islas Marianas del Norte' },
  { id: 'US-UM', name: 'Islas Ultramarinas Menores de los Estados Unidos' },
  { id: 'US-VI', name: 'Islas Vírgenes de los Estados Unidos' },
  { id: 'US-KS', name: 'Kansas' },
  { id: 'US-KY', name: 'Kentucky' },
  { id: 'US-LA', name: 'Luisiana' },
  { id: 'US-ME', name: 'Maine' },
  { id: 'US-MD', name: 'Maryland' },
  { id: 'US-MA', name: 'Massachusetts' },
  { id: 'US-MI', name: 'Míchigan' },
  { id: 'US-MN', name: 'Minnesota' },
  { id: 'US-MS', name: 'Misisipi' },
  { id: 'US-MO', name: 'Misuri' },
  { id: 'US-MT', name: 'Montana' },
  { id: 'US-NE', name: 'Nebraska' },
  { id: 'US-NV', name: 'Nevada' },
  { id: 'US-NJ', name: 'Nueva Jersey' },
  { id: 'US0036', name: 'Nueva York' },
  { id: 'US-NH', name: 'Nuevo Hampshire' },
  { id: 'US-NM', name: 'Nuevo México' },
  { id: 'US-OH', name: 'Ohio' },
  { id: 'US-OK', name: 'Oklahoma' },
  { id: 'US-OR', name: 'Oregón' },
  { id: 'US-PA', name: 'Pensilvania' },
  { id: 'US-PR', name: 'Puerto Rico' },
  { id: 'US-RI', name: 'Rhode Island' },
  { id: 'US-AS', name: 'Samoa Americana' },
  { id: 'US-TN', name: 'Tennessee' },
  { id: 'US-TX', name: 'Texas' },
  { id: 'US-UT', name: 'Utah' },
  { id: 'US-VT', name: 'Vermont' },
  { id: 'US-VA', name: 'Virginia' },
  { id: 'US-WV', name: 'Virginia Occidental' },
  { id: 'US-WA', name: 'Washington' },
  { id: 'US-DC', name: 'Washington D. C.' },
  { id: 'US-WI', name: 'Wisconsin' },
  { id: 'US-WY', name: 'Wyoming' }
]

const states = {
  BR: br,
  CL: cl,
  US: us
}

export const getStatesByCountry = (country) => {
  return states[country]
}
